import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CoursesPage from "../pages/courses/page";
import ChatGPTMasteryPage from "../pages/courses/chatgpt-mastery/page";
import MLFoundationsPage from "../pages/courses/ml-foundations/page";
import AIAgentsPage from "../pages/courses/ai-agents/page";
import AIForDevsPage from "../pages/courses/ai-for-devs/page";
import PricingPage from "../pages/pricing/page";
import FeaturesPage from "../pages/features/page";
import TestimonialsPage from "../pages/testimonials/page";
import CheckoutPage from "../pages/checkout/page";
import ContactPage from "../pages/contact/page";
import RefundPolicyPage from "../pages/refund-policy/page";
import TermsOfServicePage from "../pages/terms-of-service/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/courses",
    element: <CoursesPage />,
  },
  {
    path: "/courses/chatgpt-mastery",
    element: <ChatGPTMasteryPage />,
  },
  {
    path: "/courses/ml-foundations",
    element: <MLFoundationsPage />,
  },
  {
    path: "/courses/ai-agents",
    element: <AIAgentsPage />,
  },
  {
    path: "/courses/ai-for-devs",
    element: <AIForDevsPage />,
  },
  {
    path: "/pricing",
    element: <PricingPage />,
  },
  {
    path: "/features",
    element: <FeaturesPage />,
  },
  {
    path: "/testimonials",
    element: <TestimonialsPage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/refund-policy",
    element: <RefundPolicyPage />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfServicePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;